function hide() {
    // eslint-disable-next-line no-undef
    cordova.plugins.Keyboard.close();

}

export default {
    hide,
};
